import React from 'react'
import { Alcance } from '../Alcance';
import DatePicker from 'react-datepicker';
import { guardarMeasure, cat_fibtexFromServer1, cat_fibtexFromServer } from '../firebase';
import { doc } from 'firebase/firestore';
import { origen_input, destino_input, distancia_input } from '../pages/valores';
import { yearMeasure } from '../pages/Home';

function MedirTransporteTerrestre( props ) {
    
    const sub = props.sub

    const [nombreEntrada, setNombreEntrada] = React.useState('Transporte materia prima');
    const [origen, setOrigen] = React.useState('');
    const [destino, setDestino] = React.useState('');
    const [kilometros, setKilometros] = React.useState('');
    const [tipoVehiculo, setTipoVehiculo] = React.useState('');
    const [marcaReferencia, setMarcaReferencia] = React.useState('');
    //const [combustible, setCombustible] = React.useState('');
    const [peso, setPeso] = React.useState(0);
    const [errorPeso, setErrorPeso] = React.useState('');
    const [alcance, setAlcance] = React.useState(1);
    const [classValida, setClassValida] = React.useState('class__valida__red');
    const [isCargado, setIsCargado] = React.useState(false);
    const [cantPasajeros, setCantPasajeros] = React.useState(0);

    const [loading, setLoading] = React.useState(false);
    const [isTransporteTrabajo, setIsTransporteTrabajo] = React.useState(false);

      const handleNombreEntrada = (event) => {
        if (event.target.value === 'Transporte trabajo') {
          document.getElementById('peso_div').style.display = 'none'
          document.getElementById('id_cantPasajeros').style.display = 'block'
        }else{
          document.getElementById('peso_div').style.display = 'block'
          document.getElementById('id_cantPasajeros').style.display = 'none'
        }
        if (event.target.value === 'Transporte reciclaje') {
          setMarcaReferencia('Reciclaje')
        }
        setNombreEntrada(event.target.value);
      }
      const onClickSelectNombre =(event)=>{
        setClassValida('class__valida__green')
        setNombreEntrada(event.target.value)  
      }

      const handleOrigen = (event) => {
        setOrigen(event.target.value);
      }
      const handleDestino = (event) => {
        setDestino(event.target.value);
      }
      const handleKilometros = (event) => {
        setKilometros(event.target.value);
      }
      const handleMarcaReferencia = (event) => {
        setMarcaReferencia(event.target.value);
      }
      const handleCantPasajeros = (event) => {
        console.log(event.target.value)
        if (event.target.value > 0) {
          document.getElementById('id_inputCantPasajeros').style.border = '1px solid green'
          document.getElementById('id_inputCantPasajeros').style.color = 'green'
        }else{
          document.getElementById('id_inputCantPasajeros').style.border = '1px solid red'
          document.getElementById('id_inputCantPasajeros').style.color = 'red'
        }
        setCantPasajeros(event.target.value);
      }
      /*const handleTipoVehiculo = (event) => {
        console.log('tipoVehiculo: '+event.target.value);
        setTipoVehiculo(event.target.value);
      }
      const handleCombustible = (event) => {
        console.log('combustible: '+combustible);
        setCombustible(event.target.value);
      }*/
      const handlePeso = (event) => {
        console.log(event.target.value)
        if (event.target.value > 0) {
          document.getElementById('id_inputPeso').style.border = '1px solid green'
          document.getElementById('id_inputPeso').style.color = 'green'
          setErrorPeso('')
        }else{
          document.getElementById('id_inputPeso').style.border = '1px solid red'
          document.getElementById('id_inputPeso').style.color = 'red'
          setErrorPeso('Debe ingresar un valor!')
        }
        setPeso(event.target.value);
      }
      
      const handleAlcance = (event) => {
        setAlcance(event.target.value);
      }

      const onSubmit = async (event) => {
        event.preventDefault();
        console.log(cantPasajeros)
        if (nombreEntrada === 'Transporte trabajo' && cantPasajeros === 0) {
          document.getElementById('id_inputCantPasajeros').style.border = '1px solid red'
          document.getElementById('id_inputCantPasajeros').style.color = 'red'
          return
        }
        if (nombreEntrada !== 'Transporte trabajo' && (peso < 0 || peso === 0 || peso === '')) {
          document.getElementById('id_inputPeso').style.border = '1px solid red'
          document.getElementById('id_inputPeso').style.color = 'red'
          setErrorPeso('Debe ingresar un valor!')
          return
        }
          console.log('Enviando datos')
          let fe = sub.fe;
          if (tipoVehiculo === 'Camión turbo') { fe = sub.fe_camion_turbo }
          if (tipoVehiculo === 'Camión pesado') { fe = sub.fe_camion_pesado }
          if (tipoVehiculo === 'Tractomula') { fe = sub.fe_tractomula }
          if (tipoVehiculo === 'Automóvil') { fe = sub.fe_automovil }
          if (tipoVehiculo === 'Bus') { fe = sub.fe_bus }
          if (tipoVehiculo === 'Tren') { fe = sub.fe_tren }
          console.log(tipoVehiculo +' :: '+fe)
          const fecha_modificacion = new Date().toUTCString();
          
          let pesoIngresado = 1;
          if (peso > 0) {  pesoIngresado = peso; };
          let cantPasajerosIngresado = 1;
          if (cantPasajeros > 0) {  cantPasajerosIngresado = cantPasajeros; };
          let kilometroValor = 1;
          if (kilometros > 0) {kilometroValor = kilometros}
          
          let resultado_gco2 = kilometroValor * pesoIngresado * Number(fe) * Number(cantPasajerosIngresado);
          
          let resultado_tco2 = resultado_gco2 / 1000;
          console.log(resultado_tco2)
          let measure = {
            alcance: Number(alcance),
            categoria: sub.nombre,
            destino: destino,
            distancia_km: kilometros,
            empresa: 'Fibtex',
            fe: fe,
            nombre: nombreEntrada,
            origen: origen,
            peso_ton: peso,
            referencia_producto: marcaReferencia,
            subcategoria: sub.nombre,
            resultado_gco2: resultado_gco2,
            resultado_kgco2: resultado_tco2,
            //tipo_combustible: combustible,
            tipo_vehiculo: tipoVehiculo,
            cantidad_pasajeros: Number(cantPasajeros),
            user_email: props.user.email,
            fecha_modificacion: fecha_modificacion,
            year: yearMeasure
          }
          enviarGuardado(measure);
    }
    //const [isCargado, setIsCargado] = React.useState(false);
    const cerrarInfo=()=>{
      setIsCargado(false);
    }
    const enviarGuardado = async (measure) =>{
      setLoading(true);
        const result = await guardarMeasure(measure);
        if (result) {
            console.log(result);
            setOrigen('');
            setDestino('');
            setKilometros('');
            setMarcaReferencia('');
            setPeso('');
            setIsCargado(true);
            setCantPasajeros(0);
            
        }else{
          alert('Ocurrió un error inesperado, por favor refresque la página e intente de nuevo.')
        }
        setLoading(false);
    }

  return (
        <div >
            { loading ?
                <div className='entrada__ingresada'>
                  <div className='items__ingresada'>
                    <img src='/loading.gif'></img>
                  </div>
                </div>
              : isCargado &&
                <div className='entrada__ingresada'>
                  <div className='items__ingresada'>
                    <h4 style={{background:'transparent'}}  >Registro ingresado correctamente</h4>
                    <button className='items__ingresado__button' onClick={cerrarInfo}>Aceptar</button>
                    </div>
                </div>
            }
            <h2 style={{ whiteSpace:'pre-line', textAlign:'center'}}>Subcategoría transporte terrestre</h2>
            <form onSubmit={onSubmit}>
                <div className="form-group">
                <label>Nombre subcategoría</label>
                    <select id='selectNombre' className={classValida} style={{ borderRadius:'1.25rem',width:'100%',display:'block',padding:'0.375rem 0.75rem'}}  
                        value={nombreEntrada} 
                        onChange={handleNombreEntrada}
                        onClick={onClickSelectNombre}>
                        <option value='Transporte materia prima' >Transporte materia prima</option>
                        <option value='Transporte producto final' >Transporte producto final</option>
                        <option value='Transporte trabajo' >Transporte trabajo</option>
                        <option value='Transporte reciclaje' >Transporte reciclaje</option>
                    </select>
                </div>
                
                <div className='form-group'>
                    <label>Alcance</label>
                    <Alcance name="alcance" value={alcance} onChange={handleAlcance}></Alcance>
                </div>
                <div id='inputsBase'>
                    <div className='form-group'>
                        <label>Año seleccionado</label>
                        <label className='year__seleccionado' >{yearMeasure}</label>
                    </div>
                    {/*<div className="form-group" >
                        <label>Fecha</label>
                        <DatePicker className='datePicker__input' 
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                        />
                        <label>Este es un viaje periódico</label>
                    </div>*/}
                    <div className="form-group">
                        <label>Origen</label>
                        <input required type="text" 
                          className="form-control" 
                          value={origen} 
                          onChange={handleOrigen} 
                          placeholder="Origen"
                          onInvalid={(e) => e.target.setCustomValidity(origen_input)}
                          onInput={(e) => e.target.setCustomValidity('')}  
                        />
                    </div>
                    <div className="form-group">
                        <label>Destino</label>
                        <input required type="text" 
                        className="form-control" 
                        value={destino} 
                        onChange={handleDestino} 
                        placeholder="Destino"
                        onInvalid={(e) => e.target.setCustomValidity(destino_input)}
                        onInput={(e) => e.target.setCustomValidity('')} 
                      />
                    </div>
                    <div className="form-group">
                        <label>Distancia (km)</label>
                        <input required type="number" step="0.01" 
                          className="form-control" 
                          value={kilometros} 
                          onChange={handleKilometros} 
                          placeholder="Distancia en km"
                          onInvalid={(e) => e.target.setCustomValidity(distancia_input)}
                          onInput={(e) => e.target.setCustomValidity('')} 
                          style={{ width:'26%'}}
                        />
                   
                    </div>
                    <div className="form-group">
                        <label>Referencia o tipo producto</label>
                        <input type="text" 
                          className="form-control" 
                          value={marcaReferencia} 
                          onChange={handleMarcaReferencia} 
                          placeholder="Referencia del producto, si es transporte personal escriba personal" 
                        />
                    </div>
                    <div className="form-group" id='peso_div'>
                        <label>Peso (Toneladas)</label>
                        <input type="number" step="0.01" id='id_inputPeso'
                          className="form-control" 
                          value={peso} onChange={handlePeso} 
                          placeholder="Peso en toneladas" 
                          style={{ width:'30%'}}
                        /><label style={{color:'red'}}>{errorPeso}</label>
                    </div>
                    <div className="form-group">
                      <label>Tipo vehículo</label>
                      <select className={tipoVehiculo} style={{ borderRadius:'1.25rem',width:'100%',display:'block',padding:'0.375rem 0.75rem'}}  
                          value={tipoVehiculo} 
                          onChange={(e) => setTipoVehiculo(e.target.value)}>
                          <option value='Camión turbo' >Camión turbo</option>
                          <option value='Camión pesado' >Camión pesado</option>
                          <option value='Tractomula' >Tractomula</option>
                          <option value='Automóvil' >Automóvil</option>
                          <option value='Bus' >Bus</option>
                          <option value='Tren' >Tren</option>
                      </select>
                    </div>
                    <div className="form-group" id='id_cantPasajeros' style={{display:'none'}}>
                      <label>Cantidada pasajeros</label>
                      <input id='id_inputCantPasajeros' type="number" 
                        className="form-control" 
                        value={cantPasajeros} 
                        onChange={(e) => handleCantPasajeros(e)} 
                        placeholder="Cantidad pasajeros" 
                        style={{ width:'30%'}}
                      />
                    </div>
                </div>
                
                {
                /*<div style={{display:'none'}} className="form-group">
                    <label>Tipo combustible</label>
                    <input type="text" className="form-control" value={combustible} onChange={handleCombustible} placeholder="Tipo combustible" />
                </div>*/}
                <button className='boton__agregar__entrada'>Agregar nueva entrada</button>
            </form>
        </div>
  )
}

export { MedirTransporteTerrestre}